import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'regular_hours_worked_on_public_holidays'

export const dataPointDefinition = {
  retracedId: 'regular_hours_worked_on_public_holidays',
  name: 'Regular hours worked on public holidays',
  description:
    'Consult applicable legal requirements to determine what constitutes overtime performed on public holidays. Overtime is covered separately.\r\r\n\r\r\nIf there are no applicable legal requirements, select No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'X',
      key: 'TRUE',
      slcpIndex: 1,
      slcpOptionName: 'xna-lr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 2,
      slcpOptionName: 'xna-lr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['TRUE', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-5--3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7550,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
